import React from 'react';
import styles from './AllFilterButton.module.scss';

interface AllFilterButtonProps {
  id: string;
  label: string;
  active: boolean;
  onClick: (id: string) => void;
}

const AllFilterButton: React.FC<AllFilterButtonProps> = ({
  id,
  label,
  active,
  onClick,
}) => {
  const handleClick = () => {
    onClick(id);
  };

  return (
    <label key={label} className={styles.option}>
      <div>
        <input
          checked={active || false}
          id={label}
          name={label}
          onChange={() => handleClick()}
          type="checkbox"
        />
        <span className={styles.option__checkbox} />
      </div>
      <span className={styles.option__checkbox_text}>
        {label}
      </span>
      {/* <span className={styles.option__checkbox_count}>(9)</span> */}
    </label>
  );
};

export default AllFilterButton;
